import React, { useEffect, useState } from 'react'
import EventItem from './EventItem'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'
import { useContainerClick } from 'context/dash/ContainerClick'
import fonts from 'theme/fonts'
import { useShowAllEvents } from 'context/dash/ShowAllEvents'
import { Clock, FileText, Calendar, CheckCircle, ChevronRight } from 'react-feather'

const sectionIcons = {
    now: Clock,
    draft: FileText,
    next: Calendar,
    expired: CheckCircle,
}

export default function ListEventItems({ title, data, type, expired, onEventClick, onDropdownAction, dropdownLoading }) {
    const [selected, setSelected] = useState(false)

    const { showAllEvents, setShowAllEvents } = useShowAllEvents()
    const { containerClick } = useContainerClick()

    useEffect(() => {
        if (containerClick) {
            setSelected(false)
        }
    }, [containerClick])

    const SectionIconComponent = sectionIcons[type] || Calendar

    return (
        <Container>
            <HeaderRow>
                <SectionHeader>
                    <SectionIcon>
                        <SectionIconComponent size={16} color={colors.secondaryPurple} />
                    </SectionIcon>
                    <HeaderContent>
                        <SectionTitle>{title}</SectionTitle>
                        <SectionSubtitle>{data?.total} {data?.total === 1 ? 'evento' : 'eventos'}</SectionSubtitle>
                    </HeaderContent>
                </SectionHeader>

                {data?.total > 10 && (
                    <SeeAll
                        onClick={() => setShowAllEvents({
                            type,
                            title,
                            visible: true,
                            data: data?.items?.data,
                            total: data?.total
                        })}
                    >
                        Ver todos
                        <ChevronRight size={14} />
                    </SeeAll>
                )}
            </HeaderRow>

            <CardsGrid>
                {data && data?.items?.data?.map((el, index) => (
                    <EventItem
                        isLoading={dropdownLoading}
                        expired={expired}
                        draft={type === 'draft'}
                        key={index} data={el}
                        dropDownVisible={index === selected}
                        onEventClick={() => {
                            onEventClick(el)
                            setSelected(index)
                        }}
                        onMoreClick={() => setSelected(index)}
                        onDropdownAction={e => { onDropdownAction({ action: e, ...el }) }}
                    />
                ))}
            </CardsGrid>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    background: ${colors.neutralLight};
    border: 1px solid ${colors.neutralDark};
    border-radius: 12px;
    overflow: hidden;
`;

const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px 0 24px;

    @media screen and (max-width: ${breakpoints.sm}) {
        padding: 16px 16px 0 16px;
    }
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #F3EAFF;
    flex-shrink: 0;
`;

const HeaderContent = styled.div`
    flex: 1;
`;

const SectionTitle = styled.p`
    font-size: ${fonts.sizes.default};
    font-weight: 600;
    color: ${colors.nightDark};
    margin: 0;
    padding: 0;
    line-height: 1.3;
`;

const SectionSubtitle = styled.p`
    font-size: ${fonts.sizes.small};
    color: ${colors.night};
    margin: 0;
    padding: 0;
    line-height: 1.3;
`;

const SeeAll = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: none;
    background: transparent;
    color: ${colors.secondaryPurple};
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;

    &:hover {
        background: #F3E8FF;
    }

    &:focus-visible {
        outline: 2px solid ${colors.occasionalPurple};
        outline-offset: 2px;
    }
`;

const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    padding: 24px;

    @media screen and (max-width: ${breakpoints.sm}) {
        grid-template-columns: 1fr;
        padding: 16px;
    }
`;
